/**
 * Partner Infinite Loop Slider Module
 * Pure Vanilla JS ES6+ Continuous Infinite Marquee with Touch/Drag & Pause Interactions
 *
 * @package Gina_Theme
 */
(function() {
  'use strict';

  function initPartnerSlider() {
    const sliders = document.querySelectorAll('[data-partner-slider]');
    if (!sliders.length) return;

    sliders.forEach(function(slider) {
      const track = slider.querySelector('.partner-infinite-slider__track');
      if (!track) return;

      const items = Array.from(track.children);
      if (items.length < 2) return;

      // ─── 1. Clone items to guarantee seamless infinite loop ─────
      // We calculate total width to ensure at least 2 full duplicated sets
      const fragment = document.createDocumentFragment();
      items.forEach(function(item) {
        const clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        fragment.appendChild(clone);
      });
      track.appendChild(fragment);

      // ─── 2. Dynamic Speed Normalization (Constant px/sec) ───────
      function updateSpeed() {
        const totalItems = track.children.length;
        const halfCount = Math.floor(totalItems / 2);
        let singleSetWidth = 0;

        for (let i = 0; i < halfCount; i++) {
          const item = track.children[i];
          const style = window.getComputedStyle(item);
          const marginRight = parseFloat(style.marginRight) || 0;
          singleSetWidth += item.getBoundingClientRect().width + marginRight;
        }

        // Add gap if flex gap is used
        const trackStyle = window.getComputedStyle(track);
        const gap = parseFloat(trackStyle.gap) || 16;
        singleSetWidth += gap * halfCount;

        // Target smooth velocity: ~40px per second
        const velocity = 40;
        const duration = Math.max(18, singleSetWidth / velocity);
        track.style.animationDuration = duration + 's';
      }

      // Initial calculation after images load
      updateSpeed();
      window.addEventListener('resize', debounce(updateSpeed, 200));

      // ─── 3. Pointer & Drag Interaction (Mouse & Touch) ──────────
      let isDown = false;
      let startX = 0;
      let currentTranslate = 0;
      let dragOffset = 0;

      slider.addEventListener('mouseenter', function() {
        slider.classList.add('is-paused');
      });

      slider.addEventListener('mouseleave', function() {
        if (!isDown) {
          slider.classList.remove('is-paused');
        }
      });

      slider.addEventListener('pointerdown', function(e) {
        isDown = true;
        startX = e.clientX;
        slider.classList.add('is-paused', 'is-dragging');

        // Extract current CSS transform matrix X
        const computedStyle = window.getComputedStyle(track);
        const matrix = new DOMMatrixReadOnly(computedStyle.transform);
        currentTranslate = matrix.m41;
        track.style.transform = `translate3d(${currentTranslate}px, 0, 0)`;
      });

      window.addEventListener('pointermove', function(e) {
        if (!isDown) return;
        e.preventDefault();
        const deltaX = e.clientX - startX;
        dragOffset = currentTranslate + deltaX;
        track.style.transform = `translate3d(${dragOffset}px, 0, 0)`;
      });

      function stopDrag() {
        if (!isDown) return;
        isDown = false;
        slider.classList.remove('is-dragging');
        track.style.transform = '';
        slider.classList.remove('is-paused');
      }

      window.addEventListener('pointerup', stopDrag);
      window.addEventListener('pointercancel', stopDrag);
    });
  }

  // Utility: Simple debounce
  function debounce(fn, wait) {
    let timeout;
    return function() {
      const context = this;
      const args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function() {
        fn.apply(context, args);
      }, wait);
    };
  }

  // Export to global window namespace
  window.GinaPartnerSlider = { init: initPartnerSlider };
})();
